import { Link } from "react-router-dom";
import { UserCircle, Settings, LogOut } from "lucide-react";
import elioLogo from "@/assets/elio-monogram.png";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useAuth } from "@/hooks/useAuth";

export const AppHeader = () => {
  const { logout } = useAuth();
  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-card/80 backdrop-blur-sm">
      <div className="mx-auto flex h-12 max-w-[1400px] items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={elioLogo} alt="Elio" className="h-6 w-auto" />
          <span className="font-semibold text-sm tracking-tight text-foreground">Elio</span>
        </Link>
        <Popover>
          <PopoverTrigger asChild>
            <button className="h-8 w-8 rounded-full flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-accent transition-colors outline-none">
              <UserCircle className="h-5 w-5" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-44 p-1">
            <button className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground transition-colors">
              <Settings className="h-3.5 w-3.5" /> Settings
            </button>
            <div className="my-1 h-px bg-border" />
            <button
              onClick={logout}
              className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-sm text-destructive hover:bg-accent transition-colors"
            >
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </PopoverContent>
        </Popover>
      </div>
    </header>
  );
};
